import React from 'react';

import styled from 'styled-components';

import { Skeleton } from 'fpay-ui';

const Layout = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #fff;
  border-radius: 6px;
  padding-top: 21px;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  @media (min-width: 601px) {
    height: 150px;
    padding-top: 27px;
    padding-bottom: 23px;
    padding-left: 28px;
    padding-right: 30px;
  }
  @media (min-width: 901px) {
    height: 108px;
    padding-top: 15px;
    padding-bottom: 21px;
    padding-left: 23px;
    padding-right: 32px;
  }
`;

const LayoutCircle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: top;
  margin-right: 24px;
  @media (min-width: 601px) {
    align-items: center;
  }
`;

const LayoutData = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 601px) {
    flex-direction: row;
    width: 100%;
  }
`;

const LayoutTitles = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  @media (min-width: 601px) {
    display: none;
  }
`;

const LayoutInfo = styled.div`
  display: flex;
  flex-direction: colum;
  @media (min-width: 601px) {
    width: 100%;
    justify-content: space-between;
  }
`;

const LayoutText = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  @media (min-width: 601px) {
    width: 100%;
    max-width: 506px;
  }
  @media (min-width: 901px) {
    padding-top: 10px;
  }
`;

const LayoutButton = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  @media (min-width: 601px) {
    width: 172px;    
    align-items: center;
    justify-content: flex-end;
  }
  @media (min-width: 901px) {
    width: 338px;
    align-items: center;
    justify-content: flex-end;
  }
`;

const SkeletonLarge = styled(Skeleton)`  
  height: 18px;
`;

const SkeletonTitles = styled(SkeletonLarge)`
  display: ${(props) => (props.display ? 'flex' : 'none')};
  width: 100%;
  max-width: ${(props) => (props.large ? '444px' : '209px')};
  margin-top: ${(props) => (props.large ? '3px' : '4px')};
  @media (min-width: 601px) {
    display: ${(props) => (props.display ? 'none' : 'flex')};
    max-width: ${(props) => (props.large ? '506px' : '209px')};
  }
  @media (min-width: 901px) {
    max-width: ${(props) => (props.large ? '402px' : '209px')};
  }
`;

const SkeletonText = styled(Skeleton)`  
  height: ${(props) => (props.bold ? '25px' : '14px')};
  max-width: ${(props) => (props.bold ? '130px' : '145px')};
  margin-bottom: ${(props) => (props.bold ? '6px' : '')};
  @media (min-width: 601px) {
    margin-top: ${(props) => (props.bold ? '12px' : '9px')};
    margin-bottom: 0px;
  }
  @media (min-width: 901px) {
    display: ${(props) => (props.bold ? 'none' : 'flex')};    
  }
`;

const SkeletonButton = styled(Skeleton)`
  min-width: 80px;
  max-width: 154px;
  height: 45px;
  width: auto;
  @media (min-width: 601px) {
    width: 152px;
  }
`;

const SkeletonCircle = styled(Skeleton)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  @media (min-width: 601px) {
    width: 74px;
    height: 74px;
  }
`;

const SkeletonButton2 = styled(Skeleton)`
  display: none;
  @media (min-width: 901px) {
    display: flex;
    width: 126px;
    height: 25px;
    margin-right: 58px;
  }  
`;

const SkelettonBanner = () => {
  return (
    <Layout>
      <LayoutCircle>
        <SkeletonCircle />
      </LayoutCircle>
      <LayoutData>
        <LayoutTitles>
          <SkeletonTitles large display/>
          <SkeletonTitles display />
        </LayoutTitles>
        <LayoutInfo>
          <LayoutText>
            <SkeletonTitles large/>
            <SkeletonTitles />
            <SkeletonText bold />
            <SkeletonText />
          </LayoutText>
          <LayoutButton>
            <SkeletonButton2 />
            <SkeletonButton />
          </LayoutButton>
        </LayoutInfo>
      </LayoutData>
    </Layout>
  );
};

export default SkelettonBanner;
